import { render } from "./CategoriesFooter.vue?vue&type=template&id=d3995b88"
import script from "./CategoriesFooter.vue?vue&type=script&lang=js"
export * from "./CategoriesFooter.vue?vue&type=script&lang=js"

import "./CategoriesFooter.vue?vue&type=style&index=0&id=d3995b88&lang=css"

import exportComponent from "C:\\Users\\s.raghani\\Projects\\frontend\\PB_AT_GITHUB\\DePaybackATReloadedFrontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__